// src/services/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: '/api', // you can also set this globally elsewhere
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
